var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    [
      _c(
        "b-col",
        { attrs: { cols: "12" } },
        _vm._l(_vm.sampleDocuments, function (sampleDocument) {
          return _c("document-request-row", {
            key: sampleDocument.documentNumber,
            attrs: {
              "sample-document": sampleDocument,
              "application-id": _vm.applicationId,
              "client-username": _vm.clientUsername,
            },
          })
        }),
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }